import { render, staticRenderFns } from "./manage_home.vue?vue&type=template&id=b9b09c3c&scoped=true"
import script from "./manage_home.vue?vue&type=script&lang=js"
export * from "./manage_home.vue?vue&type=script&lang=js"
import style0 from "./manage_home.vue?vue&type=style&index=0&id=b9b09c3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b09c3c",
  null
  
)

export default component.exports